import {
  modeConstants,
  TableColumnStyle,
  translationConstants,
} from "../../../../constants";
import i18next from "i18next";
import { Stack, Switch, styled } from "@mui/material";
import { antSwitchStyle, copyToClipboard } from "../../../../system";
import Tooltip from "@mui/material/Tooltip";

export const sportNames = {
  1: "Sailing",
  2: "Kitesurfing",
  3: "Wingfoiling",
  4: "Windsurfing",
};

//Function to get sport names from IDs and join them with commas
export const getSportNames = (sportIds) => {
  return sportIds?.map((id) => i18next.t(sportNames[id])).join(", ");
};

const AntSwitch = styled(Switch)(({ theme }) => antSwitchStyle(theme));
export const getcolumns = (t, getRowData, setMode, showEditIcon) => [
  {
    id: "id",
    accessor: "id",
    name: t(translationConstants.RECORD_ID),
    cell: (row) => (
      <Tooltip
        title={<div>{t(translationConstants.COPY_TO_CLIPBOARD)}</div>}
        placement="top"
        arrow
      >
        <div
          className="truncate-text cursor-pointer"
          onClick={() => copyToClipboard(row.id)}
        >
          {row.id}
        </div>
      </Tooltip>
    ),
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: TableColumnStyle.COLUMN_WIDTH_120,
    maxWidth: TableColumnStyle.COLUMN_WIDTH_120,
  },
  {
    id: "spotInfo.name",
    name: t(translationConstants.fullName),
    selector: (row) => row.spotInfo?.name,
    reorder: true,
    sortable: true,
    sortDirection: null,
  },
  {
    id: "spotInfo.locationName",
    name: t(translationConstants.LOCATION),
    selector: (row) => row.spotInfo?.locationName,
    reorder: true,
    sortable: true,
    sortDirection: null,
  },
  {
    id: "spotInfo.usualWindDrection",
    name: t(translationConstants.PREVAILING_WIND_DIRECTION),
    selector: (row) => row.spotInfo?.usualWindDrection,
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: "225px",
    cell: (row) => (
      <div style={{ minWidth: "225px" }}>{row.spotInfo?.usualWindDrection}</div>
    ),
  },
  {
    id: showEditIcon ? "centersAvailable" : "centers[0]?.name",
    name: showEditIcon
      ? t(translationConstants.CENTERS_AVAILABLE)
      : t(translationConstants.CENTER_NAME),
    selector: showEditIcon
      ? (row) => row.centersAvailable
      : (row) => row.centers[0]?.name,
    reorder: showEditIcon ? true : false,
    sortable: showEditIcon ? true : false,
    sortDirection: null,
    minWidth: "150px",
    cell: (row) => (
      <div style={{ minWidth: "150px" }}>
        {showEditIcon ? row?.centersAvailable : row.centers[0]?.name}
      </div>
    ),
  },
  {
    id: "sportIds",
    name: t(translationConstants.SUITABLE_SPOTS),
    selector: (row) => getSportNames(row.sportIds),
    minWidth: "130px",
    cell: (row) => (
      <div style={{ minWidth: "130px" }}>{getSportNames(row.sportIds)}</div>
    ),
  },
  {
    id: "actions",
    name: t(translationConstants.Actions),
    cell: (row) => (
      <>
        <svg
          onClick={() => {
            getRowData(row);
            setMode(modeConstants.VIEW_MODE);
          }}
          width="20"
          height="20"
          // viewBox="0 0 50 16"
          viewBox="0 0 20 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.1685 8.99922C16.1685 8.99922 14.0341 13.268 9.05391 13.268C4.07371 13.268 1.93933 8.99922 1.93933 8.99922C1.93933 8.99922 4.07371 4.73047 9.05391 4.73047C14.0341 4.73047 16.1685 8.99922 16.1685 8.99922Z"
            stroke="#588930"
            strokeWidth="1.42292"
            strokeLinecap="round"
          />
          <circle
            cx="9.05381"
            cy="8.99766"
            r="2.13438"
            stroke="#588930"
            strokeWidth="1.42292"
            strokeLinecap="round"
          />
        </svg>
        {showEditIcon && (
          <svg
            onClick={() => {
              setMode(modeConstants.EDIT_MODE);
              getRowData(row);
            }}
            width="20"
            height="20"
            viewBox="20 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.4449 13.2687V9.53359H35.3778V13.2687H26.8403V4.73125H30.5754V3.66406H26.8403C26.2509 3.66406 25.7731 4.14186 25.7731 4.73125V13.2687C25.7731 13.8581 26.2509 14.3359 26.8403 14.3359H35.3778C35.9671 14.3359 36.4449 13.8581 36.4449 13.2687ZM34.9392 4.05008C34.6946 3.80355 34.3597 3.66406 34.0103 3.66406C33.6614 3.66406 33.3268 3.80324 33.0808 4.05072L28.6153 8.51625C28.2162 8.86785 27.9546 9.39104 27.9092 9.95369L27.9074 11.6692V12.2028H30.1136C30.7189 12.1613 31.2472 11.8971 31.6199 11.4672L36.0602 7.02882C36.3066 6.78247 36.445 6.44835 36.445 6.09996C36.445 5.75157 36.3066 5.41745 36.0602 5.1711L34.9392 4.05008ZM30.076 11.1359C30.3611 11.1157 30.6264 10.9831 30.8395 10.7393L34.075 7.50381L32.6054 6.03405L29.3461 9.29222C29.1299 9.48342 28.9962 9.75092 28.9747 9.99562V11.1349L30.076 11.1359ZM33.3601 5.27956L34.8296 6.7492L35.3057 6.27316C35.3519 6.22695 35.3778 6.16427 35.3778 6.09892C35.3778 6.03357 35.3519 5.97089 35.3057 5.92468L34.1832 4.80217C34.1375 4.75611 34.0753 4.73021 34.0104 4.73021C33.9455 4.73021 33.8833 4.75611 33.8376 4.80217L33.3601 5.27956Z"
              fill="#2C7465"
            />
          </svg>
        )}
      </>
    ),
  },
];
